import { render, staticRenderFns } from "./OrganismParkingAccessV2.vue?vue&type=template&id=897c6978&scoped=true&"
import script from "./OrganismParkingAccessV2.vue?vue&type=script&lang=js&"
export * from "./OrganismParkingAccessV2.vue?vue&type=script&lang=js&"
import style0 from "./OrganismParkingAccessV2.vue?vue&type=style&index=0&id=897c6978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897c6978",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomLottieAnimation: require('/app/components/atoms/common/AtomLottieAnimation.vue').default})
